import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M3.125 3.5C3.125 3.15482 3.40482 2.875 3.75 2.875H12.25C12.5952 2.875 12.875 3.15482 12.875 3.5C12.875 3.84518 12.5952 4.125 12.25 4.125H3.75C3.40482 4.125 3.125 3.84518 3.125 3.5ZM3.125 6.5C3.125 6.15482 3.40482 5.875 3.75 5.875H12.25C12.5952 5.875 12.875 6.15482 12.875 6.5C12.875 6.84518 12.5952 7.125 12.25 7.125H8.625V12.5C8.625 12.8452 8.34518 13.125 8 13.125C7.65482 13.125 7.375 12.8452 7.375 12.5V7.125H3.75C3.40482 7.125 3.125 6.84518 3.125 6.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
